import { Twitter, Linkedin, Mail, Phone, MapPin } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const LandingFooter = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-muted/30 border-t">
      <div className="container mx-auto py-16 px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="space-y-4"
          >
            <div 
              className="flex items-center gap-2 cursor-pointer"
              onClick={() => navigate("/")}
            >
              <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center">
                <span className="text-primary-foreground font-bold text-lg">C</span>
              </div>
              <span className="text-2xl font-semibold">Chito</span>
            </div>
            <p className="text-muted-foreground max-w-xs mt-2 text-left">
              The modern platform for chit fund organizers to manage their funds efficiently and securely.
            </p>
            <div className="flex space-x-4 pt-2">
              <a href="#" aria-label="Twitter" className="text-muted-foreground hover:text-foreground transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" aria-label="LinkedIn" className="text-muted-foreground hover:text-foreground transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="mailto:support@chito.in" aria-label="Email" className="text-muted-foreground hover:text-foreground transition-colors">
                <Mail className="h-5 w-5" />
              </a>
            </div>
          </motion.div>
          
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
            className="space-y-4"
          >
            <h3 className="font-medium text-lg">Company</h3>
            <ul className="space-y-3">
              <li><a href="/blog" className="text-muted-foreground hover:text-foreground transition-colors">Blog</a></li>
              <li><a href="/contact" className="text-muted-foreground hover:text-foreground transition-colors">Contact</a></li>
            </ul>
          </motion.div>
          
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
            className="space-y-4"
          >
            <h3 className="font-medium text-lg">Resources</h3>
            <ul className="space-y-3">
              <li><a href="/terms" className="text-muted-foreground hover:text-foreground transition-colors">Terms of Service</a></li>
              <li><a href="/privacy" className="text-muted-foreground hover:text-foreground transition-colors">Privacy Policy</a></li>
              <li><a href="/refund" className="text-muted-foreground hover:text-foreground transition-colors">Refund Policy</a></li>
            </ul>
          </motion.div>
          
          <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          viewport={{ once: true }}
          className="space-y-4"
        >
          <h3 className="font-medium text-lg text-center md:text-left">Contact Us</h3>
          <ul className="space-y-4 flex flex-col items-center md:items-start">
            <li>
              <a href="mailto:support@chito.in" className="text-muted-foreground hover:text-foreground transition-colors flex">
                <Mail className="h-4 w-4 mr-2 mt-1 flex-shrink-0" />
                <span>support@chito.in</span>
              </a>
            </li>
            <li>
              <a href="tel:+911234567890" className="text-muted-foreground hover:text-foreground transition-colors flex">
                <Phone className="h-4 w-4 mr-2 mt-1 flex-shrink-0" />
                <span>+91 123 456 7890</span>
              </a>
            </li>
            <li>
              <div className="text-muted-foreground flex">
                <MapPin className="h-4 w-4 mr-2 mt-1 flex-shrink-0" />
                <span>Hyderabad, India</span>
              </div>
            </li>
          </ul>
        </motion.div>
        </div>
        
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          viewport={{ once: true }}
          className="border-t mt-12 pt-8 flex flex-col md:flex-row justify-between items-center"
        >
          <p className="text-sm text-muted-foreground">
            © {currentYear} Chito. All rights reserved.
          </p>
          <p className="text-sm text-muted-foreground mt-4 md:mt-0">
            Designed and built with ❤️ in India
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default LandingFooter;
